import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavMenuItem, NavMenuDivider } from 'components/NavMenu';
import isAdmin from 'utils/session/isAdmin';
import getMyTeamsLink from './getMyTeamsLink';
import { NavMenuRouterLinkItem } from './NavMenuRouterLinkItem';
import { PLATFORM_ANNOUNCEMENTS_ROUTE } from 'utils/routes';
export function AdminAndManagerLinks() {
  var userIsAdmin = isAdmin();
  var myTeamsLink = getMyTeamsLink();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (userIsAdmin || myTeamsLink) && /*#__PURE__*/React.createElement(NavMenuDivider, null), userIsAdmin && /*#__PURE__*/React.createElement(NavMenuItem, {
    as: "a",
    id: "admin_home_button",
    href: "/admin"
  }, t('navbar_admin')), myTeamsLink && /*#__PURE__*/React.createElement(NavMenuRouterLinkItem, {
    to: myTeamsLink,
    id: "my_teams_button"
  }, t('navbar_my_teams')), userIsAdmin && /*#__PURE__*/React.createElement(NavMenuRouterLinkItem, {
    id: "platform_announcements_button",
    to: PLATFORM_ANNOUNCEMENTS_ROUTE
  }, t('navbar_platform_announcements')));
}